export const USER_ADDRESSES_FEATURE_KEY = "user_addresses";
